import React from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

type Props = {
  totalPage: number;
  currentPage: number;
};

const BorderLinearProgressCustom = styled(LinearProgress)(({ theme }) => ({
  height: 4,
  borderRadius: 4,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.mode === 'light' ? '#E9EDF4' : '',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor:
      theme.palette.mode === 'light' ? 'var(--populate-green)' : '',
  },
}));

function BorderLinearProgress({
  totalPage,
  currentPage,
}: Props) {
  const progress = (100 / totalPage) * currentPage;
  return (
    <div className="w-full my-1">
      <BorderLinearProgressCustom
        variant="determinate"
        value={Math.round(progress)}
      />
    </div>
  );
}

export default BorderLinearProgress;
